import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] text-[#F9F9F6] mt-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-5">
            <p className="eyebrow text-[#A8A8A0]">LRG Leather Botswana</p>
            <h3 className="font-serif text-3xl md:text-4xl mt-4 leading-tight tracking-tight">
              A structured, government-aligned industrial project. Already in
              motion.
            </h3>
            <p className="mt-6 text-sm text-[#C7C7BF] max-w-md leading-relaxed">
              Integrated leather processing and luxury manufacturing, anchored
              in Lobatse, Botswana. Aligned with SEZA. Built with Italian
              tannery expertise. Engineered for global luxury markets.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-[#A8A8A0]">Navigate</p>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                ["Overview", "/"],
                ["SEZA & Government", "/seza"],
                ["Supply Chain", "/supply-chain"],
                ["Execution", "/execution"],
                ["Investment", "/investment"],
                ["Financial Model", "/financial-model"],
                ["Partner Onboarding", "/partner"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                    className="inline-flex items-center gap-2 hover:text-[#C99B6E] transition-colors"
                  >
                    {label}
                    <ArrowUpRight size={14} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-[#A8A8A0]">Engagement Tracks</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-mailto-investor"
                  href="mailto:lefikaragontse@lrgholdings.com?subject=Investor%20Access%20%E2%80%94%20LRG%20Leather%20Botswana"
                  className="inline-flex items-center gap-2 hover:text-[#C99B6E] transition-colors"
                >
                  lefikaragontse@lrgholdings.com
                  <ArrowUpRight size={14} />
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-mailto-partner"
                  href="mailto:lefikaragontse@lrgholdings.com?subject=Strategic%20Partnership%20%E2%80%94%20LRG%20Leather%20Botswana"
                  className="inline-flex items-center gap-2 hover:text-[#C99B6E] transition-colors"
                >
                  lefikaragontse@lrgholdings.com
                  <ArrowUpRight size={14} />
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-mailto-government"
                  href="mailto:lefikaragontse@lrgholdings.com?subject=Institutional%20%26%20Government%20%E2%80%94%20LRG%20Leather%20Botswana"
                  className="inline-flex items-center gap-2 hover:text-[#C99B6E] transition-colors"
                >
                  lefikaragontse@lrgholdings.com
                  <ArrowUpRight size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#333330] flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-[#A8A8A0] tracking-wide">
            © {new Date().getFullYear()} LRG Holdings. All rights reserved.
          </p>
          <p className="text-[10px] uppercase tracking-[0.24em] text-[#A8A8A0]">
            Lobatse · Botswana · SEZA-aligned
          </p>
        </div>
      </div>
    </footer>
  );
}
